import { message } from "antd";
import axios from "axios";
const url = process.env.REACT_APP_API_KEY;
// const url = 'https://osool-cn32gliuoa-uc.a.run.app/api/';

export const GetMetaData = (onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
  if (localStorage.getItem("deviceId")) {
    if (!!!localStorage.getItem("tokenCi")) {
      headers.deviceId = localStorage.getItem("deviceId");
    }
  }
  axios({
    method: "get",
    url: `${url}MetaData/GetMetaData`,
    headers,
  })
    .then((response) => {
      return onSucess(response);
    })
    .catch((err) => onFail(err));
};

export const GetAllNotification = (onSuccess,onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
axios({ 
  method: 'get',
  url: `${url}GetAllNotification?Page=${0}`,  
  headers
  })
  .then((response) => {
    onSuccess(response)
  }) 
  .catch(err => onFail(err)); 
}

export const AddPushToken = (body, onSucess, onFail) => {
  const headers = {
    "Content-Type": "application/json",
    "content-language": `${localStorage.getItem("lang") || "en"}`,
  };
  if (localStorage.getItem("tokenCi")) {
    headers.Authorization = `Bearer ${localStorage.getItem("tokenCi")}`;
  }
    axios({ 
        method: 'post',
        url: `${url}AddPushToken`,
        data: body,
        headers
        })
        .then((response) => {
            return onSucess(response);
        }) 
        .catch(err => onFail(err.response.data.errors)); 
}